import controller from './controller';

const template = require('./ethernetstatus.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
